import React, { useEffect, useState, useRef } from "react";
import Helper from "helper/Common_Helper";
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { useLocation } from 'react-router-dom';
import Header from 'Components/HeaderPlain';

dayjs.extend(isSameOrAfter);

function AdminViewTable({ TableData, currentPage, totalPages, handlePageChange }) {
    const location = useLocation();
    const [eventsData, setEventsData] = useState([]);
    const today = dayjs().startOf('day');
    const hasFetchedTotal = useRef(false);

    const params = new URLSearchParams(location.search);
    let storedState = params.get('state');

    if (!storedState || storedState === 'null') {
        storedState = localStorage.getItem('filterDataState');
    }

    useEffect(() => {
        const fetchReport = async () => {
            try {
                const res = await fetch('https://ecoclubs.education.gov.in/api/school-list-state-wise', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ state: storedState })
                });

                const result = await res.json();
                const records = result.data || [];

                const cleanedData = records.map(item => ({
                    udise_id: item.udise_id,
                    school_name: item.school_name,
                    state: item.state,
                    district: item.district,
                    eduBlockName: item.eduBlockName
                }));

                setEventsData(cleanedData);

            } catch (err) {
                console.error('Failed to fetch report data:', err);
            }
        };

        fetchReport();
    }, [storedState]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    scrollToTop();

    const downloadCSV = () => {
        if (!eventsData.length) return;
    
        const headers = ["S.no", "UDISE ID", "School Name", "District", "EduBlockName/Ward No."];
        const rows = eventsData.map((item, index) => [
            index + 1,
            `"${item.udise_id || ''}"`,
            `"${item.school_name || ''}"`,
            `"${item.district || ''}"`,
            `"${item.eduBlockName || ''}"`
        ]);
    
        // Add BOM for Excel compatibility and join CSV content
        const csvContent = "\uFEFF" + [headers, ...rows].map(e => e.join(",")).join("\n");
    
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `school_list_${storedState}.csv`);
        document.body.appendChild(link); // For Firefox support
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    

    return (
        <>
            <Header />
            <div className="content">
                <div className="btmTableDivIn">
                    <div className="tableTopDiv">
                        <div className="dwnldexel" style={{ marginBottom: '1rem' }}>
                            <button className="btn btn-primary" onClick={downloadCSV}>Download CSV</button>
                        </div>
                        <h3 style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
                            StateWise Onboarded Schools Details - {storedState}
                        </h3>
                        <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                            <table rules="all" className="table">
                                <thead className="text-primary" style={{
                                    position: 'sticky',
                                    top: '0',
                                    backgroundColor: '#ffffff',
                                    zIndex: '1000',
                                    boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)'
                                }}>
                                    <tr className="tblHdngOne">
                                        <th>S.no</th>
                                        <th>UDISE ID</th>
                                        <th>School Name</th>
                                        <th>District</th>
                                        <th>EduBlockName/Ward No.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {eventsData.length > 0 ? (
                                        eventsData.map((item, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{item.udise_id || 'N/A'}</td>
                                                <td>{item.school_name || 'N/A'}</td>
                                                <td>{item.district || 'N/A'}</td>
                                                <td>{item.eduBlockName || 'N/A'}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={4} className="text-center">Data not Found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            {totalPages > 1 && (
                                <div className="mb-3">
                                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}> Previous </button>
                                    <span>Page {currentPage} of {totalPages}</span>
                                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}> Next </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AdminViewTable;
